module.exports = __webpack_public_path__ + "img/Modern-Pentathlon.183a0441.png";